import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { FileText, Settings, Image, HelpCircle, Package, Wrench, Users, TrendingUp } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const { user, token } = useAuth();
  const [stats, setStats] = useState({
    pages: 0,
    services: 0,
    products: 0,
    faqs: 0,
    images: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const [pagesRes, servicesRes, productsRes, faqsRes, imagesRes] = await Promise.all([
        axios.get(`${API_URL}/api/pages`, { headers }),
        axios.get(`${API_URL}/api/services`, { headers }),
        axios.get(`${API_URL}/api/products`, { headers }),
        axios.get(`${API_URL}/api/faqs`, { headers }),
        axios.get(`${API_URL}/api/images`, { headers })
      ]);
      setStats({
        pages: pagesRes.data.length,
        services: servicesRes.data.length,
        products: productsRes.data.length,
        faqs: faqsRes.data.length,
        images: imagesRes.data.length
      });
    } catch (error) {
      console.error('Stats yüklenemedi:', error);
    }
  };

  const menuItems = [
    { title: 'Site Ayarları', icon: Settings, href: '/admin/settings', description: 'Firma bilgileri, iletişim' },
    { title: 'Sayfalar', icon: FileText, href: '/admin/pages', description: 'Sayfa içerikleri düzenle' },
    { title: 'Hizmetler', icon: Wrench, href: '/admin/services', description: 'Hizmet ekle/düzenle' },
    { title: 'Ürünler', icon: Package, href: '/admin/products', description: 'Ürün kategorileri' },
    { title: 'SSS', icon: HelpCircle, href: '/admin/faqs', description: 'Sık sorulan sorular' },
    { title: 'Görseller', icon: Image, href: '/admin/images', description: 'Görsel yönetimi' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900">Hoş Geldiniz, {user?.username}</h1>
        <p className="text-slate-600 mt-2">Beyaz Eşya Al Sat yönetim paneline hoş geldiniz.</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
        <Card>
          <CardContent className="p-4 text-center">
            <FileText className="w-8 h-8 text-[#002FA7] mx-auto mb-2" />
            <p className="text-2xl font-bold">{stats.pages}</p>
            <p className="text-sm text-slate-600">Sayfa</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4 text-center">
            <Wrench className="w-8 h-8 text-[#002FA7] mx-auto mb-2" />
            <p className="text-2xl font-bold">{stats.services}</p>
            <p className="text-sm text-slate-600">Hizmet</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4 text-center">
            <Package className="w-8 h-8 text-[#002FA7] mx-auto mb-2" />
            <p className="text-2xl font-bold">{stats.products}</p>
            <p className="text-sm text-slate-600">Ürün</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4 text-center">
            <HelpCircle className="w-8 h-8 text-[#002FA7] mx-auto mb-2" />
            <p className="text-2xl font-bold">{stats.faqs}</p>
            <p className="text-sm text-slate-600">SSS</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4 text-center">
            <Image className="w-8 h-8 text-[#002FA7] mx-auto mb-2" />
            <p className="text-2xl font-bold">{stats.images}</p>
            <p className="text-sm text-slate-600">Görsel</p>
          </CardContent>
        </Card>
      </div>

      {/* Quick Links */}
      <h2 className="text-xl font-semibold text-slate-900 mb-4">Hızlı Erişim</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {menuItems.map((item) => (
          <Link key={item.href} to={item.href}>
            <Card className="card-hover cursor-pointer h-full">
              <CardContent className="p-6 flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-[#002FA7] text-white flex items-center justify-center flex-shrink-0">
                  <item.icon className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900">{item.title}</h3>
                  <p className="text-sm text-slate-600">{item.description}</p>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
